import apiClient from "./APIClient";

class BulkRechargeService {
  getAgentWallet = async () => {
    return await apiClient.get("/wallet/agent-balance");
  }

  bulkRecharge = async (formData) => {
    return await apiClient.post("/product-activation/bulk-recharge", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  getBulkRechargeHistory = async (params = {}) => {
    return await apiClient.get("/product-activation/get-rechargeLogs", { params });
  }

  checkJobStatus = async (jobId) => {
    return await apiClient.get(`/product-activation/bulk-recharge/status/${jobId}`);
  }

  downloadTemplate = async () => {
    const response = await apiClient.get("/recharge/download-template", {
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bulk_recharge_template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return response;
  }

  downloadReport = async (filename) => {
    const response = await apiClient.get(`/product-activation/bulk-recharge/download/${filename}`, {
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return response;
  }

  getReportDownloadUrl = (filename) => {
    return `${process.env.REACT_APP_API_URL}/product-activation/bulk-recharge/download/${filename}`;
  }
}

export default new BulkRechargeService();